export type ValidTheme = '';

export const THEME_DEFAULT = '';
export const VALID_THEMES = [THEME_DEFAULT];

export const COMPONENT_SIGNUP_BOX = 'COMPONENT_SIGNUP_BOX';
export const COMPONENT_SIGNIN_TITLE = 'COMPONENT_SIGNIN_TITLE';
export const COMPONENT_FOOTER = 'COMPONENT_FOOTER';
